import { actions } from './outsourceParty/actions'
import { getters } from './outsourceParty/getters'
import { state } from './outsourceParty/state'
import { mutations } from './outsourceParty/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
